import Vue from "vue"

import { library } from "@fortawesome/fontawesome-svg-core"
import {
  faWhatsapp,
  faTwitter,
  faFacebookF,
  faYoutube,
  faInstagram,
  faFacebookSquare,
  faLinkedin,
  faLinkedinIn
} from "@fortawesome/free-brands-svg-icons"

import {
  faUndo,
  faEyeSlash,
  faEye,
  faLock,
  faCircle,
  faTimesCircle,
  faExclamationCircle,
  faQuestionCircle,
  faFileAlt,
  faTools,
  faCaretDown,
  faCaretUp,
  faIdCard,
  faBirthdayCake,
  faInfoCircle,
  faCheckCircle,
  faAngleRight,
  faAngleLeft,
  faFileCsv,
  faSearch,
  faUser,
  faEnvelope,
  faAngleUp,
  faAngleDown,
  faDiceD6,
  faClipboardList,
  faBarcode,
  faGlobeAmericas,
  faStore,
  faDonate,
  faPlus,
  faPlusCircle,
  faQrcode,
  faFingerprint,
  faCamera,
  faArrowLeft,
  faRedoAlt,
  faBell,
  faLink,
  faMoneyBillWave,
  faPlay,
  faMapMarkerAlt,
  faShoppingCart,
  faSpinner,
  faShieldAlt,
  faSyncAlt,
  faUpload,
  faTag,
  faUsers,
  faChevronLeft,
  faChevronRight,
  faComments,
  faUserTimes,
  faComment,
  faUserSlash,
  faSave,
  faPaperPlane,
  faClock,
  faUserTie,
  faUserClock,
  faHourglassHalf,
  faPhoneAlt,
  faChevronCircleDown,
  faChevronCircleUp,
  faHouseChimneyUser,
  faLightbulb,
  faGlasses,
  faImage,
  faSun,
  faClone,
  faTriangleExclamation,
  faSliders,
  faChartBar,
  faFilter,
  faCalendarCheck
} from "@fortawesome/free-solid-svg-icons"

import { FontAwesomeLayers } from "@fortawesome/vue-fontawesome"

library.add(
  faUndo,
  faEyeSlash,
  faEye,
  faLock,
  faCircle,
  faComment,
  faTimesCircle,
  faExclamationCircle,
  faQuestionCircle,
  faFileAlt,
  faTools,
  faCaretDown,
  faCaretUp,
  faIdCard,
  faBirthdayCake,
  faInfoCircle,
  faCheckCircle,
  faAngleRight,
  faAngleLeft,
  faFileCsv,
  faSearch,
  faUser,
  faEnvelope,
  faWhatsapp,
  faTwitter,
  faFacebookF,
  faAngleUp,
  faAngleDown,
  faDiceD6,
  faClipboardList,
  faBarcode,
  faGlobeAmericas,
  faStore,
  faDonate,
  faPlus,
  faQrcode,
  faFingerprint,
  faCamera,
  faArrowLeft,
  faRedoAlt,
  faBell,
  faLink,
  faMoneyBillWave,
  faPlay,
  faInstagram,
  faYoutube,
  faFacebookSquare,
  faLinkedin,
  faLinkedinIn,
  faMapMarkerAlt,
  faShoppingCart,
  faSpinner,
  faShieldAlt,
  faSyncAlt,
  faUpload,
  faPlusCircle,
  faTag,
  faUsers,
  faChevronLeft,
  faChevronRight,
  faComments,
  faUserTimes,
  faUserSlash,
  faSave,
  faPaperPlane,
  faClock,
  faUserTie,
  faUserClock,
  faHourglassHalf,
  faPhoneAlt,
  faChevronCircleDown,
  faChevronCircleUp,
  faHouseChimneyUser,
  faLightbulb,
  faGlasses,
  faImage,
  faSun,
  faClone,
  faTriangleExclamation,
  faSliders,
  faChartBar,
  faFilter,
  faCalendarCheck
)

Vue.component("FontAwesomeLayers", FontAwesomeLayers)
